import React, { CSSProperties } from "react";
import { observer } from "mobx-react";
import { store } from "@store";

type Props = {};

@observer
export class Upload extends React.Component<Props> {
  inputStyle: CSSProperties = {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    opacity: 0.00001,
    pointerEvents: "none"
  };

  render() {
    return (
      <input
        type="file"
        ref={store().upload.inputRef}
        onBlur={store().upload.handleUpload}
        onChange={store().upload.handleUpload}
        style={this.inputStyle}
      />
    );
  }
}

export default Upload;
